import { EUI_STRING_LENGTH, getValueOfEncodedCharacter, SHORT_CODE_FORMAT } from "./shortCodesLookup.js";

/**
 * Cleans up an EUI string by removing non-alphanumeric characters and standardizing format
 * @param inputEui The EUI string to clean
 * @returns A cleaned EUI string without prefix or separators
 */
export const cleanUpEui = (inputEui: string): string => {
    let filteredEui: string;

    filteredEui = inputEui.replace(/[^a-zA-Z0-9]/g, "");
    filteredEui = filteredEui.toLowerCase();
    filteredEui = filteredEui.replace(/eui/g, "");
    return filteredEui;
};

/**
 * Validates if a short code matches the expected format by checking each character
 * against its corresponding format character.
 *
 * @param input - The short code string to validate
 * @returns A boolean indicating if the short code is valid
 */
export function isValidShortCode(input: string): boolean {
    if (input.length !== SHORT_CODE_FORMAT.length) {
        return false;
    }
    // return false if one or more characters cannot be evaluated legally (therefore returning -1)
    return !SHORT_CODE_FORMAT.split("").some(
        (formatChar, index) => getValueOfEncodedCharacter(formatChar, input[index]) === -1,
    );
}

/**
 * Basic validation of an EUI string without checking address ranges
 * @param eui The EUI to validate
 * @returns boolean indicating if the EUI has valid format
 */
export function hasValidEuiFormat(eui: string): boolean {
    const cleanedEui = cleanUpEui(eui);
    return cleanedEui.length === EUI_STRING_LENGTH;
}
